import React, { useEffect, useState } from 'react';
import { Card, Col, Row, ListGroup } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import qs from 'qs';
import styled from 'styled-components';
import { getUserSession } from '../component/userInfo';

const MyView = styled.div`
.post-view {
  padding: 1rem;
  border: .2rem solid #ececec;
  border-radius: 8px;
  margin-bottom: 1rem;
}
.post-header {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
}
.post-title {
  font-size: 1.75rem;
  font-weight: bold;
}
.post-meta {
  font-size: 0.9rem;
  color: #6c757d;
}
.post-content {
  margin-top: 1rem;
  white-space: pre-wrap;
}
.attachment-section {
  margin-top: 2rem;
}
.attachment-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.comment-section {
  margin-top: 2rem;
}
.comment-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
`;

function getExten(str){
    if (!str) return '';
    let aa = str.split('.');
    return aa[aa.length - 1];
}

function outSize(sz){
   if (!sz) return "0 바이트";
   let unit = ["바이트","KB", "MB", "GB"];
   let i = 0;
   for(i = 0; i < unit.length; i++){
       if(sz < 1024) break;
       sz = sz / 1024;
   }
   return sz.toFixed(1) + " " + unit[i];
}

function ServerImage ({imageInfo}){
    return (
      <Col md={4} className="mb-3">
        <Card>
            <Card.Img variant="top" src={"https://work.wekoinonia.org" + imageInfo.imgsrc} />
            <Card.Body>
                <Card.Title>{imageInfo.name}</Card.Title>
                <Card.Text>{outSize(imageInfo.size)}</Card.Text>
            </Card.Body>
        </Card>
      </Col>
    );
}

function Attatchment ({fileInfo}){
    const downloadUrl = `https://work.wekoinonia.org/json/fileDownload.php?path=${fileInfo.path}&filename=${fileInfo.upload_name}&realname=${fileInfo.name}`;
    return (
        <Row className="ms-2 mb-2 border-bottom align-items-center">
            <Col sm={8} className="fw-bold">
                <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
                    <i className={"bi bi-filetype-" + getExten(fileInfo.name) }></i>
                    {' '}{fileInfo.name}
                </a>
            </Col>
            <Col sm={4}  className="text-end">
                <small>{outSize(fileInfo.size)}</small>
            </Col>
        </Row>
    );
}

// New CarpoolInfo component
function CarpoolInfo({ jsonString }) {
  let carpoolData;
  try {
    carpoolData = JSON.parse(jsonString);
  } catch (e) {
    // If parsing fails, just display the original string
    return <div dangerouslySetInnerHTML={{ __html: jsonString }} />;
  }

  const reqTypeLabel = carpoolData.reqType === 'Y' ? '카풀 제공' : '카풀 요청';

  return (
    <div>
      <p><strong>요청 타입:</strong> {reqTypeLabel}</p>
      <p><strong>연락처:</strong> {carpoolData.phone}</p>
      <p><strong>출발시간:</strong> {carpoolData.departure}</p>
      <p><strong>지역:</strong> {carpoolData.area}</p>
      <p><strong>탑승인원:</strong> {carpoolData.number}</p>
      <p><strong>제목:</strong> {carpoolData.title}</p>
    </div>
  );
}

const MybbsAdminView = ()=> {
    const params = useParams();
    const location = useLocation();

    const [post, setPost] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [images, setImages] = useState([]);
    const [comments, setComments] = useState([]);
    const [bbsAdminId, setBbsAdminId] = useState('');
    const [bbsAdminTitle, setBbsAdminTitle] = useState('게시물');
    const [tableInfo, setTableInfo] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        const currentBbsId = params.mybbsId || 'archive';
        setBbsAdminId(currentBbsId);

        const query = qs.parse(location.search, {
            ignoreQueryPrefix: true
        });

        const bbsNo = query.bbsno;

        if(bbsNo){
            fetchPost(bbsNo, currentBbsId);
        }

        if(location.state) {
            if (location.state.item) {
                setBbsAdminTitle(location.state.item.title);
                setTableInfo(location.state.item);
            }
            if (location.state.page) {
                setPage(location.state.page);
            }
        }

    },[params.mybbsId, location.search, location.state]);

    const fetchPost = (bbsNo, currentBbsId) => {
        const userSession = getUserSession();
        const formData = new FormData();
        formData.append('uid', userSession.uid);
        formData.append('action', 'read');
        formData.append('db', currentBbsId);
        formData.append('dbNo', bbsNo);

        fetch('https://work.wekoinonia.org/json/mybbsAdmin.php', {
          method: 'POST',
          body: formData,
        }).then(res => res.json())
          .then(json => {
              if(json.code === "0000" && json.isExist === "Y") {
                setPost(json);
                setAttachments(json.filelist || []);
                setImages(json.imglist || []);
                if (json.comment && typeof json.comment === 'string') {
                    try {
                        const parsedComments = JSON.parse(json.comment);
                        if (Array.isArray(parsedComments)) {
                            setComments(parsedComments);
                        }
                    } catch (e) {
                        console.error("Failed to parse comments:", e);
                        setComments([]);
                    }
                } else if (Array.isArray(json.comment)) {
                    setComments(json.comment);
                }

              } else {
                alert(json.msg || "게시물을 불러오는데 실패했습니다.");
                setPost(null);
              }
          }).catch(error => {
            console.error('Error:', error);
            alert("게시물을 불러오는 중 오류가 발생했습니다.");
          });
    }

    if (!post) {
        return (
            <section className="container">
                <h1>{bbsAdminTitle} 보기</h1>
                <p>게시물을 불러오는 중이거나 존재하지 않습니다.</p>
                <Link to={`/MybbsAdmin/${bbsAdminId}`} state={{ item: tableInfo, page: page }} className="btn btn-primary">목록으로</Link>
            </section>
        );
    }

	return(
        <section className="container">
            <h1>{bbsAdminTitle} 보기</h1>
            <MyView>
                <div className="post-view">
                    <div className="post-header">
                        <h2 className="post-title">{post.title}</h2>
                        <div className="post-meta">
                            <span>작성자: {post.name}</span> |
                            <span> 수정일: {(post.udate && post.udate !== '0000-00-00 00:00:00') ? post.udate : post.idate}</span> |
                            <span> 분류: {post.content_type}</span>
                        </div>
                    </div>
                    <div className="post-content">
                        {bbsAdminId === 'carpool' ? (
                            <CarpoolInfo jsonString={post.text} />
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: post.text }} />
                        )}
                    </div>
                </div>

                {images.length > 0 &&
                    <div className="attachment-section">
                        <h3 className="attachment-title">이미지</h3>
                        <Row>
                            {images.map((image, index) => (
                                <ServerImage imageInfo={image} key={index}/>
                            ))}
                        </Row>
                    </div>
                }

                {attachments.length > 0 &&
                    <div className="attachment-section">
                        <h3 className="attachment-title">첨부파일</h3>
                        {attachments.map((file, index) =>
                            <Attatchment fileInfo={file} key={index}/>
                        )}
                    </div>
                }

                {comments.length > 0 &&
                    <div className="comment-section">
                        <h3 className="comment-title">댓글</h3>
                        <ListGroup variant="flush">
                            {comments.map((comment, index) => (
                                <ListGroup.Item key={index} className="px-0">
                                    <div className="d-flex w-100 justify-content-between">
                                        <p className="mb-1 fw-bold">{comment.name}</p>
                                        <small>{comment.idate}</small>
                                    </div>
                                    <p className="mb-1">{comment.content}</p>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </div>
                }

                <div className="mt-3 mb-5">
                    <Link to={`/MybbsAdmin/${bbsAdminId}`} state={{ item: tableInfo, page: page }} className="btn btn-primary">목록으로</Link>
                </div>
            </MyView>
		</section>
	)
}

export default MybbsAdminView;
